// extracted by mini-css-extract-plugin
export default {"helicopter-animation":"styles_helicopter-animation__XbdNX"};